module.exports = __webpack_public_path__ + "static/media/img-function-interview@3x.e58a14b9.png";